import { AbstractMessageHandler } from "@/services/rest/messages/message-handler";
import { XmlRequest } from "@/services/rest/xml-request";
import { getRequiredAttribute, getRequiredChild } from "@/utils/xml-helper-functions";

export class ACs210CasinoLeaveMessageHandler extends AbstractMessageHandler<void> {
    protected readonly requestType: string = "A.CS.2.10";

    buildRequest (request: XmlRequest): void {
        request.addChild(request.body, "action", {
            type: this.requestType
        });
    }

    protected parseMessageBody (body: Element): void {
        const action = getRequiredChild(body, "action");
        const serverCode = getRequiredAttribute(action, "servercode");

        if (serverCode !== "8230" && serverCode !== "8232") {
            // Show only error code to user
            throw new Error(serverCode);
        }
    }
}
